export default __webpack_public_path__ + "static/media/gym-gray.daa49819.svg";